//axios
import axios from "axios";

//toast
import { setToast } from "../../util/toast";

import { GET_COMPLAINT, SOLVED_COMPLAINT } from "./complaint.type";
import { apiInstanceFetch } from "../../util/api";

export const getComplaint = (type, userType) => (dispatch) => {

  apiInstanceFetch
    .get(`complaint?type=${type}&userType=${userType}`)
    .then((res) => {
      
      if (res.status) {
        dispatch({ type: GET_COMPLAINT, payload: res.complaint });
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error.message);
    });
};

export const solvedComplaint = (id) => (dispatch) => {
  apiInstanceFetch
    .patch(`complaint/complaintId?complaintId=${id}`, {})
    .then((res) => {
      if (res && res.status) {
        dispatch({ type: SOLVED_COMPLAINT, payload: res.data || { _id: id } });
        setToast("success", "Complaint Solved Successfully");
      } else {
        setToast("error", (res && res.message) || "Failed to solve complaint");
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error.message);
    });
};
